"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./DecadeView/Years.js");function t(e){return e&&e.__esModule?e:{default:e}}var r=t(require("react"));exports.default=function(t){return r.default.createElement("div",{className:"react-calendar__decade-view"},r.default.createElement(e.default,Object.assign({},t)))};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/cjs/components/ReactCalendar/DecadeView.js
// module id = 856
// module chunks = 0